import NiceModal from '@ebay/nice-modal-react';

import { Suspense, useMemo } from 'react';
import { Outlet } from 'react-router-dom';

import Button from 'components/field/Button';
import Loading from 'components/global/Loading';
import PageHeader from 'components/global/PageHeader';
import Tabs from 'components/global/Tabs';

import ImportDataModal from 'modals/ImportDataModal';

import { importActions } from 'pages/Settings/ImportExport/ImportLog/ImportLogList';

import PATHS, { mergePaths } from 'utils/paths';

import { faDownload } from '@fortawesome/pro-solid-svg-icons';

/**
 * @author @muhammedburakak
 */

const InvoiceChecker = () => {
	const tabs = useMemo(
		() => [
			{
				label: 'reconciliation',
				path: mergePaths(PATHS.INVOICE_CHECKER, PATHS.RECONCILIATION)
			},
			{
				label: 'closedShipments',
				path: mergePaths(PATHS.INVOICE_CHECKER, PATHS.CLOSED_SHIPMENTS)
			},
			{
				label: 'weightCorrOpen',
				path: mergePaths(PATHS.INVOICE_CHECKER, PATHS.WEIGHT_CORR_OPEN)
			},
			{
				label: 'weightCorrClosed',
				path: mergePaths(PATHS.INVOICE_CHECKER, PATHS.WEIGHT_CORR_CLOSED)
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importExport-icon.json.gz"
				title="invoiceChecker">
				{/* Import button for each tabs */}
				<Button
					className="mobile-hidden importDataButton"
					icon={faDownload}
					variant="borderless"
					label="dailyWeightCharge"
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
					onClick={() => NiceModal.show(ImportDataModal, importActions.invoiceCheckerDailyWeightImport)}
				/>
				<Button
					className="mobile-hidden importDataButton"
					icon={faDownload}
					variant="borderless"
					label="deliveryCompanyInvoice"
					lordIcon="https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/importData-icon.json.gz"
					onClick={() => NiceModal.show(ImportDataModal, importActions.invoiceCheckerDeliveryCompanyImport)}
				/>
			</PageHeader>
			<Tabs data={tabs} checkURL />
			<Suspense fallback={<Loading />}>
				<Outlet />
			</Suspense>
		</div>
	);
};

export default InvoiceChecker;
